{
  "enums": {
    "claimStatus": {
      "draft": "草稿",
      "submitted": "已提交",
      "accepted": "已受理",
      "denied": "已拒付",
      "paid": "已付款"
    },
    "chargeStatus": {
      "pending": "待处理",
      "unbilled": "未开账",
      "posted": "已入账",
      "billed": "已开账",
      "adjusted": "已调整",
      "voided": "已作废"
    },
    "statementDelivery": {
      "print": "打印",
      "email": "电子邮件",
      "both": "打印和电子邮件",
      "mail": "邮寄"
    },
    "statementStatus": {
      "generated": "已生成",
      "sent": "已发送",
      "viewed": "已查看"
    },
    "denialStatus": {
      "new": "新建",
      "inReview": "审核中",
      "appealing": "申诉中",
      "resolved": "已解决",
      "writtenOff": "已核销"
    },
    "denialPriority": {
      "low": "低",
      "medium": "中",
      "high": "高"
    },
    "claimType": {
      "professional": "专业服务",
      "institutional": "机构",
      "dental": "牙科",
      "pharmacy": "药房"
    },
    "paymentMethod": {
      "cash": "现金",
      "check": "支票",
      "creditCard": "信用卡",
      "debitCard": "借记卡",
      "bankTransfer": "银行转账",
      "digitalWallet": "电子钱包",
      "insurance": "保险"
    },
    "paymentSource": {
      "patient": "患者",
      "insurance": "保险",
      "thirdParty": "第三方"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "患者 ID 为必填项",
      "encounterIdRequired": "就诊 ID 为必填项",
      "payerIdRequired": "付款方 ID 为必填项",
      "chargeCodeRequired": "收费代码为必填项",
      "unitPriceRequired": "单价为必填项",
      "amountRequired": "金额为必填项",
      "amountPositive": "金额必须大于零",
      "chargeSelectionRequired": "请至少选择一项收费"
    }
  },
  "pages": {
    "statements": {
      "title": "账单结算单",
      "labels": {
        "dashboard": "仪表板",
        "patient": "患者",
        "from": "起始",
        "to": "截止",
        "batchGenerate": "批量生成",
        "previewStatement": "预览结算单",
        "generatePrint": "生成并打印",
        "generateEmail": "生成并发邮件",
        "printEmail": "打印和电子邮件",
        "print": "打印",
        "email": "电子邮件"
      },
      "placeholders": {
        "searchPatient": "按姓名或病历号搜索..."
      },
      "aria": {
        "periodFrom": "结算单周期起始",
        "periodTo": "结算单周期截止"
      },
      "table": {
        "header": {
          "statementHistory": "结算单历史",
          "patient": "患者",
          "mrn": "病历号",
          "date": "日期",
          "amount": "金额",
          "delivery": "送达方式",
          "status": "状态"
        },
        "preview": {
          "modal": "结算单预览",
          "patientStatement": "患者结算单",
          "patient": "患者:",
          "mrn": "病历号:",
          "statementDate": "结算单日期:",
          "period": "周期:",
          "lineItemHeader": {
            "date": "日期",
            "description": "描述",
            "charges": "费用",
            "payments": "付款",
            "balance": "余额"
          },
          "openingBalance": "期初余额",
          "totals": "合计",
          "amountDue": "应付金额"
        }
      },
      "states": {
        "generating": "生成中...",
        "loading": "正在生成预览...",
        "noPatients": "未找到患者",
        "noStatementData": "无可用结算单数据",
        "loadingHistory": "正在加载历史...",
        "noStatementsGenerated": "尚未生成结算单",
        "selectedPatientId": "已选患者 ID:{{id}}"
      },
      "toast": {
        "generated": "结算单已生成",
        "generatedError": "生成结算单失败",
        "batchStarted": "批量生成已开始:已排队 {{count}} 份结算单",
        "batchError": "启动批量生成失败"
      }
    },
    "claims": {
      "title": "理赔管理",
      "labels": {
        "dashboard": "仪表板",
        "createClaim": "创建理赔",
        "filters": "筛选",
        "submit": "提交",
        "appeal": "申诉",
        "denialReason": "拒赔原因",
        "expandHint": "展开理赔以在专用理赔页面查看明细项。",
        "cancel": "取消"
      },
      "filter": {
        "allStatuses": "所有状态"
      },
      "placeholders": {
        "filterPayer": "按付款方筛选..."
      },
      "aria": {
        "claimDateFrom": "理赔日期从",
        "claimDateTo": "理赔日期至"
      },
      "table": {
        "header": {
          "claimNumber": "理赔编号",
          "patient": "患者",
          "payer": "付款方",
          "total": "总计",
          "status": "状态",
          "submitted": "已提交",
          "actions": "操作"
        }
      },
      "modal": {
        "createClaim": "从费用创建理赔",
        "patientId": "患者 ID *",
        "payerId": "付款方 ID *",
        "selectCharges": "选择费用（已选 {{selected}} 项）",
        "noBilledCharges": "该患者没有未开账单的费用"
      },
      "states": {
        "loading": "正在加载理赔...",
        "noClaims": "未找到理赔",
        "creating": "正在创建..."
      },
      "toast": {
        "created": "理赔已创建",
        "createdError": "创建理赔失败",
        "submitted": "理赔已提交",
        "submittedError": "提交理赔失败",
        "resubmitted": "理赔已重新提交以申诉",
        "resubmittedError": "重新提交理赔失败",
        "patientPayerRequired": "患者和付款方为必填项",
        "chargeRequired": "至少选择一项费用"
      }
    },
    "charges": {
      "title": "费用管理",
      "labels": {
        "dashboard": "仪表板",
        "newCharge": "新建费用",
        "totalChargesPeriod": "费用总计（周期）",
        "filters": "筛选",
        "cancel": "取消"
      },
      "filter": {
        "allStatuses": "所有状态"
      },
      "placeholders": {
        "filterPatient": "按患者筛选..."
      },
      "aria": {
        "serviceDateFrom": "服务日期从",
        "serviceDateTo": "服务日期至"
      },
      "table": {
        "header": {
          "date": "日期",
          "patient": "患者",
          "encounter": "就诊",
          "code": "代码",
          "description": "说明",
          "qty": "数量",
          "unitPrice": "单价",
          "total": "总计",
          "status": "状态",
          "actions": "操作"
        }
      },
      "actions": {
        "void": "作废"
      },
      "modal": {
        "voidCharge": "作废费用",
        "voidChargeConfirm": "作废费用 {{code}} - {{description}}（{{amount}}）？",
        "reason": "原因 *",
        "reasonPlaceholder": "请输入作废原因..."
      },
      "states": {
        "loading": "正在加载费用...",
        "noCharges": "此周期内未找到费用",
        "voiding": "正在作废..."
      },
      "toast": {
        "voided": "费用已作废",
        "voidedError": "作废费用失败",
        "reasonRequired": "原因为必填项"
      }
    },
    "payments": {
      "title": "付款登记",
      "labels": {
        "dashboard": "仪表板",
        "uploadEraEob": "上传 ERA/EOB",
        "postPayment": "登记付款",
        "totalPaymentsPeriod": "付款总额（周期）",
        "filters": "筛选",
        "cancel": "取消"
      },
      "placeholders": {
        "filterPatient": "按患者筛选..."
      },
      "aria": {
        "paymentDateFrom": "付款日期（起）",
        "paymentDateTo": "付款日期（止）"
      },
      "table": {
        "header": {
          "date": "日期",
          "patient": "患者",
          "claimNumber": "理赔编号",
          "amount": "金额",
          "method": "方式",
          "reference": "参考",
          "postedBy": "登记人"
        }
      },
      "modal": {
        "postPayment": "登记付款",
        "patientId": "患者 ID *",
        "claimId": "理赔 ID（可选）",
        "claimIdHint": "未应用付款请留空",
        "amount": "金额 *",
        "method": "方式 *",
        "referenceNumber": "参考编号",
        "referenceHint": "支票号、交易 ID 等",
        "notes": "备注"
      },
      "states": {
        "loading": "正在加载付款...",
        "noPayments": "此周期内未找到付款",
        "posting": "正在登记..."
      },
      "toast": {
        "posted": "付款登记成功",
        "postedError": "付款登记失败",
        "patientAmountRequired": "患者和金额为必填项",
        "validAmount": "请输入有效金额",
        "eraEobSoon": "ERA/EOB 上传即将推出"
      }
    },
    "chargeForm": {
      "title": "创建费用",
      "labels": {
        "patientId": "患者 ID *",
        "encounterId": "就诊 ID *",
        "chargeCode": "费用代码 *",
        "description": "说明",
        "cptCode": "CPT 代码",
        "quantity": "数量 *",
        "unitPrice": "单价 *"
      },
      "placeholders": {
        "chargeCode": "搜索费用主数据...",
        "cptCode": "搜索 CPT 操作代码..."
      },
      "buttons": {
        "cancel": "取消",
        "create": "创建费用"
      },
      "toast": {
        "created": "费用已创建",
        "createdError": "创建费用失败"
      }
    },
    "claimForm": {
      "title": "创建理赔",
      "labels": {
        "patientId": "患者 ID *",
        "encounterId": "就诊 ID *",
        "payerId": "付款方 ID *",
        "claimType": "理赔类型 *",
        "diagnosisCodes": "诊断代码",
        "selectCharges": "选择费用（已选 {{selected}} 项）",
        "notes": "备注"
      },
      "placeholders": {
        "diagnosisCodes": "逗号分隔的 ICD-10 代码（如 J06.9, R05）"
      },
      "buttons": {
        "cancel": "取消",
        "create": "创建理赔"
      },
      "toast": {
        "created": "理赔已创建",
        "createdError": "创建理赔失败"
      }
    },
    "paymentForm": {
      "title": "登记付款",
      "labels": {
        "patientId": "患者 ID *",
        "claimId": "理赔 ID",
        "amount": "金额 *",
        "method": "付款方式 *",
        "source": "来源",
        "referenceNumber": "参考编号",
        "notes": "备注"
      },
      "placeholders": {
        "claimId": "可选 — 关联到理赔",
        "reference": "交易或支票参考号"
      },
      "buttons": {
        "cancel": "取消",
        "post": "登记付款"
      },
      "toast": {
        "recorded": "付款已记录",
        "recordedError": "记录付款失败"
      }
    },
    "denials": {
      "title": "拒付管理",
      "subtitle": "跟踪和管理理赔拒付",
      "placeholders": {
        "search": "搜索理赔..."
      },
      "filter": {
        "all": "全部"
      },
      "checkbox": {
        "assignedToMe": "分配给我"
      },
      "table": {
        "header": {
          "claimNumber": "理赔编号",
          "patient": "患者",
          "denialCode": "拒付代码",
          "denialReason": "拒付原因",
          "amount": "金额",
          "daysRemaining": "剩余天数",
          "status": "状态",
          "assignedTo": "负责人",
          "actions": "操作"
        }
      },
      "actions": {
        "review": "审核",
        "appeal": "申诉",
        "writeOff": "核销",
        "cancel": "取消"
      },
      "modal": {
        "appealReason": "申诉原因",
        "appealPlaceholder": "请描述申诉原因...",
        "submitAppeal": "提交申诉",
        "writeOffTitle": "核销拒付",
        "writeOffConfirm": "确定要将理赔 {{claimNumber}} 以 {{amount}} 核销吗？此操作无法撤销。",
        "writeOffButton": "核销"
      },
      "states": {
        "loading": "正在加载拒付...",
        "noDenials": "未找到拒付",
        "submitting": "正在提交..."
      },
      "toast": {
        "updateError": "更新拒付状态失败",
        "movedToReview": "理赔 {{claimNumber}} 已移至审核",
        "appealSubmitted": "申诉已提交",
        "writtenOff": "理赔 {{claimNumber}} 已核销"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
